import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as stakeholder from '../stakeholder'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: stakeholder.RESOURCE.payload.dimension.partialId,
      partialId: stakeholder.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      "Support likely required for this stakeholder's successful adoption of the change.",
    isOptional: true,
    name: 'Support Needs',
    partialId: PartialId.Standard.create('support_needs'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
